import { render, staticRenderFns } from "./lyrics.vue?vue&type=template&id=21c8fc8a&"
import script from "./lyrics.vue?vue&type=script&lang=js&"
export * from "./lyrics.vue?vue&type=script&lang=js&"
import style0 from "./lyrics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports